import { FC } from 'react';
import { Form, Input, Select } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/lib/select';
import ModalAtom, { ModalAtomProps } from 'components/atoms/ModalAtom';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import { EditUserFormValues, EditUserFormValuesNames } from './resources/config';

export interface EditUserModalLiterals {
  title: string;
  mainButtonText: string;
  secondaryButtonText: string;
  usernameLabel: string;
  usernamePlaceholder: string;
  clientLabel: string;
  rolesLabel: string;
  rolesPlaceholder: string;
  requiredFieldText: string;
}

export interface Props extends ModalAtomProps {
  form: FormInstance<EditUserFormValues>;
  literals: EditUserModalLiterals;
  userRoleList: (DefaultOptionType)[];
  clientList: { value: string, label: string }[];
  onFinish: (values: EditUserFormValues) => void;
  loading: boolean;
  isRoleVisible: boolean;
};

export const EditUserModal: FC<Props> = ({
  form,
  literals,
  userRoleList,
  clientList,
  onCancel,
  onFinish,
  open,
  loading,
  isRoleVisible,
}) => {
  const {
    title,
    mainButtonText,
    secondaryButtonText,
    usernameLabel,
    usernamePlaceholder,
    clientLabel,
    rolesLabel,
    rolesPlaceholder,
    requiredFieldText,
  } = literals;

  return (
    <ModalAtom
      title={title}
      onCancel={onCancel}
      footer={[
        <DefaultButton
          key={'back'}
          onClick={onCancel}
          title={secondaryButtonText}
        />,
        <PrimaryButton
          key={'submit'}
          loading={loading}
          title={mainButtonText}
          onClick={() => form.submit()}
        />,
      ]}
      open={open}
      destroyOnClose
    >
      <Form form={form} layout={'vertical'} onFinish={onFinish}>
        <Form.Item
          label={usernameLabel}
          name={EditUserFormValuesNames.USERNAME}
          rules={[{ required: true, message: requiredFieldText }]}
        >
          <Input disabled={loading} placeholder={usernamePlaceholder} />
        </Form.Item>
        {isRoleVisible && (
          <Form.Item
            label={clientLabel}
            name={EditUserFormValuesNames.CLIENT}
            rules={[{ required: true, message: requiredFieldText }]}
          >
            <Select
              options={clientList}
              placeholder={rolesPlaceholder}
              showSearch
              filterOption={(input: string, option?: { label: string; value: string }) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        )}
        {isRoleVisible && (
          <Form.Item
            label={rolesLabel}
            name={EditUserFormValuesNames.ROLES}
            rules={[{ required: true, message: requiredFieldText }]}
          >
            <Select mode={'multiple'} options={userRoleList} placeholder={rolesPlaceholder} />
          </Form.Item>
        )}
      </Form>
    </ModalAtom>
  );
};
